var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "photo-lower-bar-button-group" }, [
    _c(
      "div",
      {
        staticClass: "photo-lower-bar-button",
        class: { "disabled-btn": _vm.groupsExistsCount <= 1 },
        on: {
          click: function($event) {
            return _vm.confirm()
          }
        }
      },
      [
        _c("SVGPhotoDelete", { staticClass: "lb-svg" }),
        _vm._v(" "),
        _c(
          "span",
          { staticClass: "photo-lower-bar-button-text extra-left-padding" },
          [_vm._v("Удалить группу")]
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.routeName === "groupingPlanesActive",
            expression: "routeName === 'groupingPlanesActive'"
          }
        ],
        staticClass: "photo-lower-bar-button",
        on: {
          click: function($event) {
            return _vm.editSelectedGroup()
          }
        }
      },
      [
        _c("SVGAdminEditRow", { staticClass: "lb-svg" }),
        _vm._v(" "),
        _c(
          "span",
          { staticClass: "photo-lower-bar-button-text extra-left-padding" },
          [_vm._v("Редактировать группу")]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }